<template>
  <div v-loading="loading" element-loading-spinner="atom-audit-loader">
    <div class="rebuttals-tracking-actions">
      <el-button class="hiaButton" plain round size="mini" :disabled="getSelectedRecords().length === 0" @click="initNotify">Notify Original Auditors</el-button>
      <div class="rebuttals-tracking-actions__right">
        <RebuttalCalculationsHelp :isLevel2Audit="true" />
        <el-dropdown trigger="click" @command="handleTableCommand">
          <span class="el-dropdown-link">
            <i title="table actions" class="mdi mdi-dots-horizontal" style="font-size: 20px; cursor: pointer"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="download">Download</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <RebuttalsTrackingTable ref="rebuttalsTrackingTable" rebuttalType="ORIGINAL_AUDITOR" :tableData="tableData" :hideDetails="hideDetails" :updateAcctList="updateAcctList" :projectId="projectPK" notificationRecordType="Ambulatory" @select-record="selectRecord" @select-all="localSelectAll" />
    <RebuttalNotifyDialog :visible.sync="showNotify" notifyTarget="ORIGINAL_AUDITOR" :selectedRows="getSelectedRecords()" :sender="user.fullName" :myRecordsUrl="`/my-projects/${projectPK}?type=Ambulatory`" :projectId="projectPK" recordType="Ambulatory" @confirm="postNotify" />
    <el-dialog :visible.sync="dialogVisible" center destroy-on-close width="75%">
      <accountList v-if="dialogVisible" :header="detailsHeader" :ascTableIds="subAscTableIds" :showRebuttalStatus="true"></accountList>
    </el-dialog>
  </div>
</template>

<script>
  import axios from '@/utilities/axios-global'
  import { mapState, mapMutations, mapActions } from 'vuex'
  import accountList from '@/views/reports/dashboards/accoutList'
  import RebuttalsTrackingTable from './components/RebuttalsTrackingTable'
  import RebuttalCalculationsHelp from './components/RebuttalCalculationsHelp'
  import RebuttalNotifyDialog from './components/RebuttalNotifyDialog'
  import { isOriginalAuditorNotifySelectable } from './components/rebuttalTrackingSelect'
  import rebuttalTrackingTableCommands from './rebuttalTrackingTableCommands'

  export default {
    name: 'ASCRebuttalsTrackingByOriginalAuditor',
    mixins: [rebuttalTrackingTableCommands],
    props: ['ascTableIds', 'dashboards', 'hideDetails', 'codeType'],
    data: function () {
      return {
        tableData: [],
        loading: false,
        dialogVisible: false,
        detailsHeader: '',
        subAscTableIds: [],
        showNotify: false
      }
    },
    components: {
      accountList,
      RebuttalsTrackingTable,
      RebuttalCalculationsHelp,
      RebuttalNotifyDialog
    },
    methods: {
      ...mapMutations('rebuttalTracking/', ['SET_ASCORIGINALAUDITOR_SELECTED', 'CLEAR_ASCORIGINALAUDITOR_SELECTED', 'SET_ASC_REBUTTAL_TRACKING_REFRESH_FUNC']),
      ...mapActions('outpatientReviews/', ['POST_NOTIFY_CODERS']),
      selectRecord(payload) {
        if (!isOriginalAuditorNotifySelectable(payload.row)) {
          return
        }
        this.$set(payload.row, 'checked', payload.checked)
        this.SET_ASCORIGINALAUDITOR_SELECTED({
          checked: payload.checked,
          originalAuditor: payload.row.originalAuditor,
          originalAuditorId: payload.row.originalAuditorId,
          originalAuditorEmail: payload.row.originalAuditorEmail,
          accountStatus: payload.row.accountStatus,
          accountNumbers: payload.row.accountNumbers
        })
      },
      localSelectAll(checked) {
        this.CLEAR_ASCORIGINALAUDITOR_SELECTED()
        this.tableData.forEach((row) => {
          if (!isOriginalAuditorNotifySelectable(row)) {
            this.$set(row, 'checked', false)
            return
          }
          this.$set(row, 'checked', checked)
          if (checked) {
            this.SET_ASCORIGINALAUDITOR_SELECTED({
              checked: true,
              originalAuditor: row.originalAuditor,
              originalAuditorId: row.originalAuditorId,
              originalAuditorEmail: row.originalAuditorEmail,
              accountStatus: row.accountStatus,
              accountNumbers: row.accountNumbers
            })
          }
        })
      },
      getSelectedRecords() {
        return this.ascOriginalAuditorSelected
      },
      initNotify() {
        this.showNotify = !this.showNotify
      },
      async postNotify(payload) {
        try {
          await this.POST_NOTIFY_CODERS(payload)
          this.showNotify = false
          this.$message({
            message: 'Original Auditors Notification Successful',
            type: 'success'
          })
          await this.getData()
        } catch (err) {
          this.showNotify = false
          this.$message({
            message: err.message,
            type: 'error'
          })
        }
      },
      async getData() {
        const payload = {
          ascTableIds: this.ascTableIds,
          projectId: this.projectPK,
          notificationRecordType: 'Ambulatory'
        }
        try {
          this.loading = true
          const response = await axios.post(`${this.baseApiUrl}/reports/dashboard/outpatientRebuttalOutcomesByOriginalAuditor`, payload)
          this.tableData = response.data
          const selected = this.ascOriginalAuditorSelected
          this.tableData.forEach((row) => {
            const wasSelected = selected.some((s) => s.originalAuditor === row.originalAuditor)
            this.$set(row, 'checked', wasSelected && isOriginalAuditorNotifySelectable(row))
          })
        } catch (err) {
          this.tableData = []
        } finally {
          this.loading = false
        }
      },
      updateAcctList(row) {
        this.detailsHeader = row.originalAuditor
        this.subAscTableIds = row.accountNumbers
        this.dialogVisible = !this.dialogVisible
      }
    },
    computed: {
      ...mapState('user/', ['baseApiUrl', 'user']),
      ...mapState('managedLists/projects/', ['projectPK']),
      ...mapState('rebuttalTracking/', ['ascOriginalAuditorSelected'])
    },
    mounted: async function () {
      this.SET_ASC_REBUTTAL_TRACKING_REFRESH_FUNC(() => this.getData())
      await this.getData()
    },
    beforeDestroy: function () {
      this.SET_ASC_REBUTTAL_TRACKING_REFRESH_FUNC(null)
      this.CLEAR_ASCORIGINALAUDITOR_SELECTED()
    },
    watch: {
      ascTableIds: async function () {
        await this.getData()
      }
    }
  }
</script>

<style scoped>
  .rebuttals-tracking-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .rebuttals-tracking-actions__right {
    display: flex;
    align-items: center;
    gap: 8px;
  }
</style>
